import type { WorldInterface } from '@/types/worlds';

/**
 * Resolve the label for the world's Tables tab. When the world has a
 * `rollName` build-option modification with a non-blank label, that overrides
 * the generic label (e.g. "Hero's Journey" for a Savage Rifts world).
 * The first `rollName` modification wins.
 */
export function resolveTablesTabLabel(
  world: WorldInterface | null | undefined,
  genericLabel: string,
): string {
  const rollName = world?.modifications?.find(
    (m) => m.configuration?.path === 'rollName',
  );
  const override = rollName?.configuration?.label;
  return override && override.trim().length > 0 ? override : genericLabel;
}
